/**
 * Topics that are explicitly mapped in Manage Curriculum (board + academic year + subject).
 */
import api from '../services/api';
import { ACADEMIC_YEAR_BOARD_SUBJECT_TOPICS } from '../config/Config';

async function fetchPaginatedList(firstUrl) {
  let url = firstUrl;
  let all = [];
  while (url) {
    const res = await api.get(url);
    const data = res.data;
    if (Array.isArray(data)) {
      all = data;
      break;
    }
    all = all.concat(data.results || []);
    url = data.next || null;
  }
  return all;
}

export function buildCurriculumTopicOptions({ rows = [], topics = [], board, academicYear, subject }) {
  if (!board || !academicYear || !subject) return [];

  const topicById = new Map(topics.map((topic) => [String(topic.id), topic]));
  const byId = new Map();
  for (const row of rows) {
    if (
      row.is_active === false
      || String(row.board) !== String(board)
      || String(row.academic_year) !== String(academicYear)
      || String(row.subject) !== String(subject)
      || row.topic == null
    ) {
      continue;
    }

    const key = String(row.topic);
    const masterTopic = topicById.get(key);
    const name = row.topic_name || masterTopic?.topic || masterTopic?.name || `Topic #${row.topic}`;
    if (!byId.has(key)) {
      byId.set(key, {
        ...(masterTopic || {}),
        id: row.topic,
        topic: name,
        name,
      });
    }
  }

  return Array.from(byId.values()).sort((a, b) =>
    String(a.topic).localeCompare(String(b.topic), undefined, { sensitivity: 'base' })
  );
}

/**
 * @returns {Promise<Array<{ id: number, topic: string, name: string }>>}
 */
export async function fetchCurriculumTopicOptions({ board, academicYear, subject }) {
  if (board == null || board === '' || academicYear == null || academicYear === '' || subject == null || subject === '') {
    return [];
  }
  const params = new URLSearchParams({
    board: String(board),
    academic_year: String(academicYear),
    subject: String(subject),
    is_active: 'true',
    page_size: '10000',
  });
  const rows = await fetchPaginatedList(`${ACADEMIC_YEAR_BOARD_SUBJECT_TOPICS}?${params.toString()}`);
  return buildCurriculumTopicOptions({ rows, board, academicYear, subject });
}
